import { lookupTicketCode } from "@/js/ticketCodeLookup.js";
import { Logger } from "@/js/utils/Logger.js";

export default {
  data() {
    return {
      ticketSearchCode: "",
      ticketResult: null,
      ticketModalOpen: false,
      ticketLookupLoading: false,
      ticketLookupError: null,
    };
  },
  methods: {
    async executeTicketLookup(code = this.ticketSearchCode) {
      if (!code) {
        return;
      }

      this.ticketLookupLoading = true;
      this.ticketLookupError = null;
      this.$store.commit("showLoading");
      try {
        const result = await lookupTicketCode({ code, store: this.$store });
        if (!result) {
          this.ticketLookupError = "not-found";
          this.$store.commit("showMessage", "存在しないコードです");
          return;
        }
        this.ticketResult = result;
        this.ticketModalOpen = true;
      } catch (error) {
        Logger.error(error);
        this.ticketLookupError = "unexpected";
        this.$store.commit("showMessage", "エラーが発生しました");
      } finally {
        this.ticketLookupLoading = false;
        this.$store.commit("hideLoading");
      }
    },
  },
};
